import { Form } from 'antd';
import BaseModal from 'basic-ui-lib/components/Modal/BaseModal';
import { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { setPageLoading } from 'widgets/PageLoading';
import mediaApis from 'modules/media/services/apis';
import { toast } from 'react-toastify';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import { getMessageError } from 'services/response';
import InputLarge from 'basic-ui-lib/components/Input/InputLarge';

export interface CreateFolderModalRef {
  open: (currentPath: string) => void;
}
interface Props {}

interface FormValues {
  name: string;
}

const CreateFolderModal = forwardRef<CreateFolderModalRef, Props>(({}, ref) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [, mutate] = useGetManageLibrary(true);

  useImperativeHandle(ref, () => ({
    open: (currentPath: string) => {
      setCurrentPath(currentPath);
      setIsOpen(true);
    },
  }));

  const onClose = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleFinish = async (values: FormValues) => {
    try {
      setPageLoading(true);

      const res = await mediaApis.createMediaFolder(values.name, currentPath);

      if (res?.data?.data) {
        toast.success('Create folder successful');
        mutate(currentPath);
        onClose();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Create folder failed');
    } finally {
      setPageLoading(false);
    }
  };
  return (
    <BaseModal
      title='Create Folder'
      isOpen={isOpen}
      width={1000}
      onClose={onClose}
      okText='Continue'
      onOk={handleSubmit}
    >
      <Container>
        <Form layout='vertical' form={form} onFinish={handleFinish}>
          <Form.Item name='name' rules={[{ required: true, message: 'Please input folder name' }]}>
            <InputLarge placeholder='Please enter folder name' />
          </Form.Item>
        </Form>
      </Container>
    </BaseModal>
  );
});

CreateFolderModal.displayName = 'CreateFolderModal';
export default CreateFolderModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0 50px;
`;
